import { firebaseSignOut } from "../lib/firebase";

/**
 * Signed in with Google, but the address is not on the beta allowlist. Shown
 * instead of the app so the rejection is explicit — otherwise every API call
 * would just fail with a 401 and the UI would look broken.
 */
export default function NotInvited({ email }: { email: string | null }) {
  return (
    <div className="login-scene relative flex min-h-screen items-center justify-center overflow-hidden bg-bg px-4 text-text">
      <div aria-hidden="true" className="login-orb login-orb-1" />
      <div aria-hidden="true" className="login-orb login-orb-2" />

      <div className="login-card card-shadow relative w-full max-w-sm rounded-2xl border border-border bg-surface/80 p-8 text-center backdrop-blur-xl">
        <p className="font-serif text-3xl font-semibold tracking-tight">Boort</p>
        <p className="mt-4 text-sm leading-relaxed text-muted">
          Boort is in private beta and{" "}
          <span className="text-text">{email ?? "this account"}</span> isn’t on the list yet.
        </p>
        <button
          type="button"
          onClick={() => void firebaseSignOut()}
          className="mt-6 w-full rounded-lg border border-border bg-bg px-5 py-3 text-sm font-medium text-text transition-colors hover:border-accent"
        >
          Sign in with a different account
        </button>
      </div>
    </div>
  );
}
